export default {"src":"/_next/static/media/laptop.1e67c0b2.svg","height":95,"width":118,"blurWidth":0,"blurHeight":0};